"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.toSlices = exports.processSlices = void 0;
var fields_1 = require("../fields");
var slice_mapper_1 = require("./slice-mapper");
var processSlices = function (mapper, prismicSlices, logger) {
    if (!prismicSlices) {
        return undefined;
    }
    var slices = prismicSlices.reduce(function (acc, prismicSlice) {
        if (fields_1.toBoolean(prismicSlice.primary.enabled, { defaultValue: true })) {
            var fn = logger.toConstValue(prismicSlice === null || prismicSlice === void 0 ? void 0 : prismicSlice.slice_type, mapper);
            var slice = fn === null || fn === void 0 ? void 0 : fn(prismicSlice, logger);
            return slice ? __spreadArray(__spreadArray([], acc), [slice]) : acc;
        }
        return acc;
    }, []);
    return slices.length ? slices : undefined;
};
exports.processSlices = processSlices;
var toSlices = function (prismicSlices, logger) {
    return exports.processSlices(slice_mapper_1.sliceMapper, prismicSlices, logger);
};
exports.toSlices = toSlices;
//# sourceMappingURL=process-slices.js.map